// src/api/apiInstance.ts
import axios, { AxiosInstance } from 'axios';
import store from '../core/redux/store';

const apiInstance: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000',
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true, // if you want cookies to be sent
});

// Add interceptors for auth tokens
apiInstance.interceptors.request.use(
    (config) => {
        const token = store.getState().auth.token;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

apiInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle global errors (401, 403, etc.)
        if (error.response?.status === 401) {
            console.warn('Unauthorized! Redirecting to login...');
            // you can trigger a logout or redirect
        }
        return Promise.reject(error);
    }
);

export default apiInstance;
